import { Grid, Typography } from '@mui/material';
import { currency } from '@shared/hooks/currencies';

const InfoValueRow = ({
  label,
  value,
  boldLeft = false,
  boldRight = false,
  mt = 0,
  mb = 0,
  color = '#000',
  isPrice = false,
  isInUSD = false,
  formatted = false,
  pago = false,
  fontSize,
  gridTemplateColumns = '65% 35%',
}) => {
  if (
    value === undefined ||
    value === null ||
    (!formatted && isPrice && Number.isNaN(Number(value)))
  ) {
    return null;
  }

  let displayValue = value;

  if (isPrice && !formatted) {
    displayValue = currency(value, isInUSD);
  }

  // fontSize responsive por defecto
  const defaultFontSize = fontSize || {
    xs: '16px',
    md: '17px',
    lg: '14px',
    xl: '15px',
  };

  return (
    <Grid
      container
      sx={{
        mt,
        mb,
        display: 'grid',
        gridTemplateColumns,
        alignItems: 'center',
      }}
    >
      <Typography
        sx={{
          fontSize: defaultFontSize,
          color,
          fontWeight: boldLeft ? 700 : 'normal',
          textAlign: 'left',
          lineHeight: 'normal',
        }}
      >
        {label}
      </Typography>

      <Typography
        sx={{
          fontSize: defaultFontSize,
          color: pago ? '#EC2E20' : color,
          fontWeight: boldRight ? 700 : 'normal',
          textAlign: 'left',
          lineHeight: 'normal',
        }}
      >
        {displayValue}
      </Typography>
    </Grid>
  );
};

export default InfoValueRow;
